export default __webpack_public_path__ + "static/media/videoHome1.63441659.mp4";